define("@ember/-internals/views/lib/views/states/destroying", ["exports", "@ember/error", "@ember/-internals/views/lib/views/states/default"], function (_exports, _error, _default3) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var destroying = Object.assign({}, _default3.default, {
    appendChild() {
      throw new _error.default("You can't call appendChild on a view being destroyed");
    },
    rerender() {
      throw new _error.default("You can't call rerender on a view being destroyed");
    }
  });
  var _default2 = _exports.default = Object.freeze(destroying);
});